import React from 'react';
import Footer from '../../components/Footer';

const EFFECTIVE_DATE = '12 April 2026';

function PrivacyPage() {
  return (
    <main className="doc-page">
      <div className="doc-container">
        <div className="doc-header">
          <h1 className="doc-title">Privacy Policy</h1>
          <p className="doc-date">Effective Date: {EFFECTIVE_DATE}</p>
        </div>

        <div className="doc-body">
          <p>
            This Privacy Policy explains how Hold On ("we," "our," or "us") collects, uses, and
            protects your information when you use our iOS application. By using Hold On, you agree
            to the practices described in this policy.
          </p>

          <section className="doc-section">
            <h2><span className="section-num">1.</span> Data We Collect</h2>
            <p>
              Hold On is designed with privacy as a core principle. All app data stays on your
              device. We do not collect or transmit personal information such as your name, email
              address, or IP address.
            </p>
            <p>The following data is stored locally on your device only:</p>
            <ul>
              <li>Apps you choose to monitor and your daily usage limits</li>
              <li>Screen time usage data for tracked apps</li>
              <li>Nudge history (nudges shown, outcomes, timestamps)</li>
              <li>Streak and pause history</li>
              <li>Onboarding inputs (name, age bracket, screen time goal)</li>
              <li>Weekly report data</li>
            </ul>
            <p>
              We may receive anonymized crash logs and basic device diagnostics via Apple's standard
              tools (device model, iOS version). We do not have access to this data in an
              identifiable form.
            </p>
            <p>
              We also collect anonymized analytics data via PostHog to understand how users move
              through onboarding, which features they use, and paywall conversion rates. This data
              is not linked to your identity.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">2.</span> Screen Time Data</h2>
            <p>
              Hold On uses Apple's FamilyControls and DeviceActivity frameworks to detect when you
              approach or exceed your daily app limits. This data never leaves your device. It is
              not transmitted to us or any third party.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">3.</span> How We Use Your Data</h2>
            <p>
              All on-device data collected by Hold On is used solely to operate the app on your
              device:
            </p>
            <ul>
              <li>To display nudges at the right time and track their effectiveness</li>
              <li>To calculate your streak and pause history</li>
              <li>To generate your Weekly Report</li>
              <li>To personalise the app experience based on your usage patterns</li>
            </ul>
            <p>
              Anonymized analytics data is used only to improve the app experience. No data is used
              for advertising. No data is sold or shared with third parties.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">4.</span> Third-Party Services</h2>
            <p>We rely on the following third-party tools to operate the app:</p>
            <ul>
              <li>
                <strong>Apple App Store</strong> — handles subscription purchases and payments
                according to Apple's own privacy policy.
              </li>
              <li>
                <strong>PostHog (Cloud)</strong> — for product analytics including onboarding
                funnel, feature usage, and paywall conversion. Data is anonymized and stored on
                PostHog's cloud servers. No personally identifiable information is intentionally
                transmitted.
              </li>
            </ul>
            <p>
              The only network calls made by Hold On are to PostHog for anonymized analytics and to
              Apple for subscription management. No personal data is transmitted over the network.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">5.</span> Your Privacy Controls</h2>
            <p>
              Since no user account is created and no personal data is stored outside your device,
              your data is entirely under your control. Deleting the app from your device removes
              all locally stored data permanently.
            </p>
            <p>
              If you wish to request deletion of analytics data associated with your device,
              contact us at getholdonapp@gmail.com and we will process the request with PostHog.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">6.</span> Children's Privacy</h2>
            <p>
              Hold On is intended for users aged 13 and above. We do not knowingly collect personal
              information from children under 13. Since all personal data is stored locally on
              device and no personal data is transmitted to us, there is no personal data for us to
              hold or delete.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">7.</span> Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be reflected
              with a new "Effective Date" at the top of this page. Continued use of the app after
              changes go into effect constitutes your acceptance of the updated policy.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">8.</span> Contact</h2>
            <p>
              If you have any questions about this policy, reach out at:{' '}
              <a href="mailto:getholdonapp@gmail.com" className="doc-link">getholdonapp@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default PrivacyPage;
